import React from 'react';

export const DeliveryServiceSkeleton: React.FC = () => {
    return (
        <div className="osb-v3-delivery-selection osb-v3-delivery-skeleton">
            {/* Header Skeleton */}
            <div className="osb-v3-delivery-selection__header">
                <div className="osb-v3-delivery-selection__back-button-wrapper">
                    {/* Back Button Placeholder */}
                    <div className="skeleton-box skeleton-back-btn"></div>
                </div>
                {/* Title Placeholder */}
                <div className="skeleton-box skeleton-title"></div>
                {/* Subtitle Placeholder */}
                <div className="skeleton-box skeleton-subtitle"></div>
            </div>

            {/* Group 1 Skeleton (e.g. DropOff) */}
            <div className="osb-v3-delivery-selection__group">
                <div className="skeleton-box skeleton-group-title"></div>
                <div className="skeleton-box skeleton-card"></div>
                <div className="skeleton-box skeleton-card"></div>
            </div>

            {/* Group 2 Skeleton (e.g. Collection) */}
            <div className="osb-v3-delivery-selection__group">
                <div className="skeleton-box skeleton-group-title"></div>
                <div className="skeleton-box skeleton-card"></div>
            </div>

            {/* Actions Skeleton */}
            <div className="osb-v3-delivery-selection__actions">
                <div className="skeleton-box skeleton-continue-btn"></div>
            </div>
        </div>
    );
};
